import { render, staticRenderFns } from "./backpack-float.vue?vue&type=template&id=8609a2a6&scoped=true"
import script from "./backpack-float.vue?vue&type=script&lang=js"
export * from "./backpack-float.vue?vue&type=script&lang=js"
import style0 from "./backpack-float.vue?vue&type=style&index=0&id=8609a2a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8609a2a6",
  null
  
)

export default component.exports